import PropTypes from 'prop-types';
import { Link as RouterLink } from 'react-router-dom';
import { styled } from '@mui/material/styles';
import { Box, Link, Typography, Avatar } from '@mui/material';
import { useState, useEffect } from 'react';
import { PATH_DASHBOARD } from '../../../routes/paths';
import useAuth from "../../../hooks/useAuth";
import Label from '../../../components/Label';


const RootStyle = styled('div')(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  padding: theme.spacing(2, 2.5),
  borderRadius: Number(theme.shape.borderRadius) * 1.5,
  backgroundColor: theme.palette.grey[500_12],
  transition: theme.transitions.create('opacity', {
    duration: theme.transitions.duration.shorter,
  }),
}));

NavbarAccount.propTypes = {
  isCollapse: PropTypes.bool,
};

export default function NavbarAccount({ isCollapse }) {

  const [profile, setPro] = useState();
  const { user } = useAuth();

  useEffect(() => {
    setPro(user);
  }, [user]);

  return (
      <RootStyle
        sx={{
          ...(isCollapse && {
            bgcolor: 'transparent',
          }),
        }}
      >
        <Avatar src={''} alt={profile?.profile?.first_name} />

        <Box
          sx={{
            ml: 2,
            transition: (theme) =>
              theme.transitions.create('width', {
                duration: theme.transitions.duration.shorter,
              }),
            ...(isCollapse && {
              ml: 0,
              width: 0,
            }),
          }}
        >
          <Typography variant="subtitle2" noWrap>
            {profile?.profile?.first_name} &nbsp;
            {profile?.profile?.last_name}
          </Typography>
          <Typography variant="body2" noWrap sx={{ color: 'text.secondary' }}>
            {user.roles.map((item, index) => (
              <Label key={item.id || index} color="error">
                <span>{item.name}</span>
              </Label>
            ))}
          </Typography>
        </Box>
      </RootStyle>
   
  );
}
